import request from '@/providers/http-service'
const url = `${process.env.VUE_APP_API_DOMAIN}/unified-code`

/**
 * 区域基本管理
 * start
 */
// 根据街道-社区ID获取下级列表
export function getPointLevelThreeListById(params) {
  return request({
    url: url + '/gh-point-level/getPointLevelThreeListById',
    method: 'get',
    params
  })
}
// 新增修改单条数据
export function eventEdit(params) {
  return request({
    url: url + '/gh-event-manger/edit',
    method: 'post',
    data: params
  })
}
// 修改点位
export function updatePointLevel(params) {
  return request({
    url: url + '/gh-point-level/updatePointLevel',
    method: 'post',
    data: params
  })
}
/**
 * 区域基本管理
 * end
 */
/**
 * 事项管理
 * start
 */

// 列表事项目录类型列表
export function selList(params) {
  return request({
    url: url + '/gh-event-type/selList',
    method: 'post',
    data: params
  })
}
// 是否启用切换开关-类型
export function changeState(params) {
  return request({
    url: url + '/gh-event-type/changeState',
    method: 'get',
    params
  })
}

// 新增修改单条数据-类型
export function edit(params) {
  return request({
    url: url + '/gh-event-type/edit',
    method: 'post',
    data: params
  })
}
// 更新编辑初始规则
export function editRule(params) {
  return request({
    url: url + '/gh-event-manger/editRule',
    method: 'post',
    data: params
  })
}
// 新增或编辑自定义规则
export function editOtherRule(params) {
  return request({
    url: url + '/gh-event-point-other-rule/editOtherRule',
    method: 'post',
    data: params
  })
}
// 更新编辑初始规则
export function detailEvent(params) {
  return request({
    url: url + '/gh-event-manger/detail',
    method: 'get',
    params
  })
}
// 更新编辑初始规则
export function changeReportState(params) {
  return request({
    url: url + '/gh-event-manger/changeReportState',
    method: 'get',
    params
  })
}
// 查询单条数据
export function detailOther(params) {
  return request({
    url: url + '/gh-event-point-other-rule/detail',
    method: 'get',
    params
  })
}
// 对自定义的改成使用初始化规则
export function useInitRule(params) {
  return request({
    url: url + '/gh-event-point-other-rule/useInitRule',
    method: 'get',
    params
  })
}
// 点位事项管理分页
export function mangerPonitRelPage(params) {
  return request({
    url: url + '/gh-event-manger/mangerPonitRelPage',
    method: 'post',
    data: params
  })
}
// 事项与点位关系切换开关
export function creatAndChangeEventPointRelState(params) {
  return request({
    url: url + '/gh-event-point-other-rule/creatAndChangeEventPointRelState',
    method: 'post',
    data: params
  })
}
// 事项管理表分页查询
export function eventPage(params) {
  return request({
    url: url + '/gh-event-manger/page',
    method: 'post',
    data: params
  })
}

// 任务清单数据
export function newEventPage(params) {
  return request({
    url: url + '/extend-infinite-task-index-batch/freeBatchPage',
    method: 'post',
    data: params
  })
}

// 是否启用切换开关-事项
export function eventChangeState(params) {
  return request({
    url: url + '/gh-event-manger/changeState',
    method: 'get',
    params
  })
}

// 删除单条事项（判断下级
export function delEventEdit(params) {
  return request({
    url: url + '/gh-event-manger/del',
    method: 'get',
    params
  })
}
// 删除批量事项（判断下级
export function delBatchEventEdit(params) {
  return request({
    url: url + '/gh-event-manger/delBatch',
    method: 'post',
    data: params
  })
}
/**
 * 事项管理
 * end
 */
/**
 * 事项标准管理
 * start
 */

// 事项标准管理分页查询
export function indexPage(params) {
  return request({
    url: url + '/gh-event-index/page',
    method: 'post',
    data: params
  })
}
// 新增与修改事项标准与点位的配置关系
export function editAndModifyPointRel(params) {
  return request({
    url: url + '/gh-event-index/editAndModifyPointRel',
    method: 'post',
    data: params
  })
}
// 修改或批量修改事项标准与点位的配置关系
export function modifyPointRel(params) {
  return request({
    url: url + '/gh-event-index/modifyPointRel',
    method: 'post',
    data: params
  })
}
// 查询单条数据
export function indexDetail(params) {
  return request({
    url: url + '/gh-event-index/detail',
    method: 'get',
    params
  })
}
// 复制一个点位标准
export function copyIndex(params) {
  return request({
    url: url + '/gh-event-index/copyIndex',
    method: 'get',
    params
  })
}
// 复制一个点位标准
export function delIndex(params) {
  return request({
    url: url + '/gh-event-index/del',
    method: 'get',
    params
  })
}
// 删除批量事项标准
export function delBatchIndex(params) {
  return request({
    url: url + '/gh-event-index/delBatch',
    method: 'post',
    data: params
  })
}
// 复制一个点位标准
export function changeStateIndex(params) {
  return request({
    url: url + '/gh-event-index/changeState',
    method: 'get',
    params
  })
}
/**
 * 事项标准管理
 * end
 */
/**
 * 部件类型管理
 * start
 */
// 分页查询部件类型列表
export function getPartsTypeListPage(params) {
  return request({
    url: url + '/gh-parts-type/getPartsTypeListPage',
    method: 'post',
    data: params
  })
}
// 添加部件类型
export function addPartsType(params) {
  return request({
    url: url + '/gh-parts-type/addPartsType',
    method: 'post',
    data: params
  })
}
// 修改部件类型
export function updatePartsType(params) {
  return request({
    url: url + '/gh-parts-type/updatePartsType',
    method: 'post',
    data: params
  })
}
// 删除部件类型
export function delPartsType(params) {
  return request({
    url: url + '/gh-parts-type/delPartsType',
    method: 'post',
    data: params
  })
}
/**
 * 部件类型管理
 * end
 */

export function delEventType(params) {
  return request({
    url: url + '/gh-event-type/del',
    method: 'get',
    params
  })
}
// 数据源导入
export function importExtendClRk(params) {
  return request({
    url: url + '/extend-cl-rk/importExtendClRk',
    method: 'post',
    data: params
  })
}
// 数据源导入
export function useRuleTable(params) {
  return request({
    url: url + '/extend-cl-rk/useRuleTable',
    method: 'get',
    params
  })
}

// ---用户标签---
// 添加标签
export function userTagaddTag(params) {
  return request({
    url: url + '/userTag/addTag',
    method: 'post',
    data: params
  })
}

// 删除标签
export function userTagdelete(params) {
  return request({
    url: url + `/userTag/delete/${params.id}`,
    method: 'delete',
    data: params
  })
}

// 修改标签
export function userTagupdate(params) {
  return request({
    url: url + '/userTag/update',
    method: 'post',
    data: params
  })
}

// 查询所有标签类型
export function userTagtagTypes(params) {
  return request({
    url: url + '/userTag/tagTypes',
    method: 'get',
    params
  })
}

// 分页查询标签
export function userTagpage(params) {
  return request({
    url: url + '/userTag/page',
    method: 'post',
    data: params
  })
}

// ---用户标签关系---
// 导出人员标签
export function exportUserTagRelation(params) {
  return request({
    url: url + '/userTagRelation/exportUserTagRelation',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}

// 导入
export function importUserTagRelation(params) {
  return request({
    url: url + '/userTagRelation/importUserTagRelation',
    method: 'post',
    data: params,
  })
}

// 下载模板
export function generateImportFile(params) {
  return request({
    url: url + '/userTagRelation/generateImportFile',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}

// 删除用户标签关系
export function userTagRelationdelete(params) {
  return request({
    url: url + `/userTagRelation/delete/${params.id}`,
    method: 'delete',
    data: params
  })
}

// 批量删除用户标签关系
export function deleteUserTagRelationList(params) {
  return request({
    url: url + `/userTagRelation/deleteUserTagRelationList`,
    method: 'post',
    data: params
  })
}


// 修改用户标签关系
export function userTagRelationupdate(params) {
  return request({
    url: url + `/userTagRelation/update`,
    method: 'post',
    data: params
  })
}


// 查询用户标签关系详情
export function userTagRelationdetail(params) {
  return request({
    url: url + `/userTagRelation/detail/${params.id}`,
    method: 'get',
    params
  })
}

// 分页查询用户标签关系
export function userTagRelationpage(params) {
  return request({
    url: url + `/userTagRelation/page`,
    method: 'post',
    data: params
  })
}

// 添加用户标签关系
export function userTagRelationadd(params) {
  return request({
    url: url + `/userTagRelation/add`,
    method: 'post',
    data: params
  })
}

// 批量添加用户标签关系
export function userTagRelationaddList(params) {
  return request({
    url: url + `/userTagRelation/addList`,
    method: 'post',
    data: params
  })
}

// 新增建筑物信息
export function buildingsave(params) {
  return request({
    url: url + `/building/save`,
    method: 'post',
    data: params
  })
}

// 修改建筑物信息
export function buildingupdate(params) {
  return request({
    url: url + `/building/update`,
    method: 'post',
    data: params
  })
}

// 分页查询建筑物列表
export function buildingpage(params) {
  return request({
    url: url + `/building/page`,
    method: 'post',
    data: params
  })
}

// 批量删除建筑物信息
export function buildingdelete(params) {
  return request({
    url: url + `/building/delete/batch`,
    method: 'delete',
    data: params
  })
}

// 导出人员标签
export function buildingexport(params) {
  return request({
    url: url + '/building/exportBuilding',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}

// 导入
export function buildingimport(params) {
  return request({
    url: url + '/building/importBuilding',
    method: 'post',
    data: params,
  })
}

// 居民互动列表
export function wenjuanpage(params) {
  return request({
    url: url + `/wenjuan/page`,
    method: 'post',
    data: params
  })
}

// 居民互动新增修改
export function wenjuancrateOrUpdate(params) {
  return request({
    url: url + `/wenjuan/crateOrUpdate`,
    method: 'post',
    data: params
  })
}

// 居民互动删除
export function wenjuandel(params) {
  return request({
    url: url + `/wenjuan/del`,
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/base.js